/* eslint-disable vue/valid-v-slot */

import alert from '@/plugins/alert'
import { TeacherExam } from '@/plugins/api'
/* eslint-disable no-unused-vars */

export default {
  namespaced: true,
  state: {
    count: 0,
    teachers: [],
    teacherSearchParams: {},
    pageText: '',
    loading: false,
  },
  actions: {
    async fetchTeacherExams(_, options) {
      return await TeacherExam.fetch({ ...options })
    },
    async fetchTeacherExam(_, id) {
      return await TeacherExam.fetchOne(id)
    },
    async createTeacherExam(_, data) {
      return await TeacherExam.create(data)
    },
    async updateTeacherExam(_, { id, ...data }) {
      return await TeacherExam.update(id, { ...data })
    },
    async countTeacherExams(_, options) {
      return await TeacherExam.count(options)
    },
    async removeTeacherExam(_, id) {
      await TeacherExam.remove(id)
      alert.success('Bỏ giáo viên ra khỏi kỳ thi thành công')
    },
  },
}
